<template lang="pug"
src='./mechanical-systems-addition.pug'>

</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import saveBtn from '@/common/components/saveBtn.vue'

export default {
	name: 'mechanical-systems-addition',
	props: ['project', 'control', 'readonly', 'findControlTextByKey'],
	components: { saveBtn },
	data () {
		return {
			nHVAC: [1, 2, 3],
			numStoriesList: [],
			waterHeaterOpts: [],
			waterHeaterOptsReplacing: [],
			wichAccordion: '',
			RepfourtyFeetNewDuct: false,
			RepthreeQNewDuct: false,
			ReplessTwelveFeetDuct: false,
			subRadio: 0,
			accor1: false,
			accor2: false,
			accor3: false,

			existSysExtAdd: false,
			repExistHVACSys: false,
			newSysAddExistSysRem: false,
			secondAccordionSubOption: '',
			heatSysStore: [],
			waterHeaterOptsStore: [],
			projType: {},
			typeLabel: 'Addition',
			projConst: []
		}
	},
	beforeMount () {
		const waterHeat = Vue.e24.formService.controlArrayToObject(this.control.waterHeat)
		this.projConst = process.env.PROJ_CONST
		this.projConst.waterHeater.type = waterHeat
		this.waterHeaterOpts = _.filter(this.control.waterHeat, (opt) => {
			return opt.value !== waterHeat.TANKHE.value
		})
		this.waterHeaterOptsReplacing = _.filter(this.control.waterHeat, (opt) => {
			return opt.value !== waterHeat.TANKSOL.value
		})
	},
	created: function () {
		// Load num stories list
		const numStoriesAdtn = this.project.addition.numStoriesAdtn
		this.numStoriesList = (numStoriesAdtn > 1) ? _.range(1, numStoriesAdtn) : [1]
		this.readAccordValues()
		this.electricHome(this.project.mechSystems.allElectric)
		this.projType = process.env.PROJTYPE
		if (this.project.takeoff === this.projType.conversion) {
			this.typeLabel = 'Conversion'
		} else {
			this.typeLabel = 'Addition'
		}
	},
	methods: {
		electricHomeChange (isElectric) {
			this.electricHome(isElectric)
		},
		electricHome (isElectric) {
			if (isElectric) {
				this.heatSysStore = this.control.heatSys
				this.waterHeaterOptsStore = this.waterHeaterOpts
				this.control.heatSys = _.filter(this.control.heatSys, (hetElem) => {
					// console.log('hetElem.text', hetElem.text)
					return (hetElem.text.toLowerCase().indexOf('heatpump') !== -1)
				})
				this.waterHeaterOpts = _.filter(this.waterHeaterOpts, (hetElem) => {
					// console.log('hetElem.text', hetElem.text)
					return (hetElem.text.toLowerCase().indexOf('heatpump') !== -1)
				})
			} else {
				if (this.heatSysStore.length > 0) {
					this.control.heatSys = this.heatSysStore
					this.waterHeaterOpts = this.waterHeaterOptsStore
				}
			}
		},
		HVACSysRemainChange (value) {
			if (this.project.mechSystems.HVACSysRem.length < value) {
				// E24-30: compute how many to add once, up front -- the old
				// loop bound re-read the array's own (growing) length on
				// every iteration, which silently undershot for any value
				// above 2.
				const toAdd = value - this.project.mechSystems.HVACSysRem.length
				for (let x = 0; x < toAdd; x++) {
					this.project.mechSystems.HVACSysRem.push({
						type: '',					// Type of system
						ductLoc: '',				// Supply duct location
						fourtyFeetNewDuct: false,	// More than 40 feet new ducts
						threeQNewDuct: false		// More than 75% of new ducts
					})
				}
			} else {
				this.project.mechSystems.HVACSysRem = this.project.mechSystems.HVACSysRem.slice(0, value)
			}
		},
		HVACSysRepChange (value) {
			if (this.project.mechSystems.HVACSysRep.length < value) {
				// E24-30: see HVACSysRemainChange()'s comment above.
				const toAdd = value - this.project.mechSystems.HVACSysRep.length
				for (let x = 0; x < toAdd; x++) {
					this.project.mechSystems.HVACSysRep.push({
						type: '',					// Type of system
						ductLoc: '',				// Supply duct location
						fourtyFeetNewDuct: false,	// More than 40 feet new ducts
						threeQNewDuct: false,		// More than 75% of new ducts
						lessTwelveFeetDuct: false	// Less Twelve Feet Duct
					})
				}
			} else {
				this.project.mechSystems.HVACSysRep = this.project.mechSystems.HVACSysRep.slice(0, value)
			}
		},
		HVACSysAddChange (value) {
			if (this.project.mechSystems.HVACSysAdd.length < value) {
				// E24-30: see HVACSysRemainChange()'s comment above.
				const toAdd = value - this.project.mechSystems.HVACSysAdd.length
				for (let x = 0; x < toAdd; x++) {
					this.project.mechSystems.HVACSysAdd.push({
						type: '',					// Type of system
						ductLoc: '',				// Supply duct location
						// fourtyFeetNewDuct: false,	// More than 40 feet new ducts
						// threeQNewDuct: false,		// More than 75% of new ducts
						lessTwelveFeetDuct: false		// Less Twelve Feet Duct
					})
				}
			} else {
				this.project.mechSystems.HVACSysAdd = this.project.mechSystems.HVACSysAdd.slice(0, value)
			}
		},
		addSystem () {},
		isThisClickIt (value) {
			this.wichAccordion = value

			if (value === 'firstAccordion') {
				this.accor1 = true
				this.accor2 = false
				this.accor3 = false
				this.project.mechSystems.repExistHVACSys = 1
			} else if (value === 'secondAccordion') {
				this.accor1 = false
				this.accor2 = true
				this.accor3 = false
				this.project.mechSystems.repExistHVACSys = 2
				this.writeCheckStates()
			} else if (value === 'thirdAccordion') {
				this.accor1 = false
				this.accor2 = false
				this.accor3 = true
				this.project.mechSystems.repExistHVACSys = 3
				this.writeCheckStates()
			}
		},
		writeCheckStates () {
			this.project.mechSystems.HVACSys = this.subRadio
		},
		readAccordValues () {
			// this.RepfourtyFeetNewDuct = this.project.mechSystems.HVACSysRep[0].fourtyFeetNewDuct
			this.subRadio = this.project.mechSystems.HVACSys
			if (this.project.mechSystems.repExistHVACSys === 1) {
				this.wichAccordion = 'firstAccordion'
				this.accor1 = true
				this.accor2 = false
				this.accor3 = false
			}
			if (this.project.mechSystems.repExistHVACSys === 2) {
				this.wichAccordion = 'secondAccordion'
				this.accor1 = false
				this.accor2 = true
				this.accor3 = false
			}
			if (this.project.mechSystems.repExistHVACSys === 3) {
				this.wichAccordion = 'thirdAccordion'
				this.accor1 = false
				this.accor2 = false
				this.accor3 = true
			}
		},
		waterHeaterChange () {
			switch (this.project.mechSystems.waterHeatSys) {
			case 'addNewKeepOld':
				if (this.project.mechSystems.addNewAndKeep.type === this.projConst.waterHeater.type.HEATPUMP.value) {
					this.project.mechSystems.addNewAndKeep.location = this.projConst.waterHeater.heatpumpDefLoc
				}
				break
			case 'addNewAndReplace':
				if (this.project.mechSystems.addNewAndReplace.type === this.projConst.waterHeater.type.HEATPUMP.value) {
					this.project.mechSystems.addNewAndReplace.location = this.projConst.waterHeater.heatpumpDefLoc
				}
				break
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/tabs-components/mechanical-systems-addition.vue